import http from '@/api/common'

export default {
  authUser (credentials, callback, error) {
    http.auth(credentials, callback, error)
  }
}



// WEBPACK FOOTER //
// ./src/api/endpoints/auth.js